<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";
import apibtoast from "@/helpers/apibtoast";

export default {
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [apigeneric, apibtoast],
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      AboneveritabaniData: {},
      AboneveritabaniId: this.$route.params.AboneveritabaniId,
      LangId: this.$route.params.LangId,
      Title: this.$route.params.Title


    };
  },
  methods: {
    Get() {

      if(this.LangId=="tr"){
      this.ActionsSingleGet({
        Service: "aboneveritabanlari",
        Id: this.AboneveritabaniId,
      }).then((res) => {
        this.AboneveritabaniData = res.Data;
        
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+this.LangId
      }).then((res) => {
        for(let LangData in res.Data){
          this.ActionsFilterGet({
          Service: "aboneveritabanlaritranslations",
          Page: this.Page,
          Filter: "&Langid="+ res.Data[LangData].Id + "&Aboneveritabanlariid=" + this.AboneveritabaniId
        }).then((res) => {
          this.AboneveritabaniData = res.Data[0];
          if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
        }
      });

      
    }
    }
  },
};
</script>
        
<template>
  <Loader>
    <Layout>
      <Banner />
      <div class="title c-flex flex-column mt-3 col-md-8 mx-auto"
        style="background-color: #0071c5; height: 50px; padding: 10px; box-shadow: 5px 7px 5px #888888; border-radius: 10px;">
        <p class="h2 text-center" style="color: white">{{ $t("aboneveritabanlari.Title") }}</p>
      </div>
      <div class="news-detail">
        <div class="title c-flex flex-column mb-2">
          <h5>{{AboneveritabaniData.Veritabaniadi}}</h5>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-10 mx-auto">
              <div class="news">
                <div class="image">
                  <img :src="$config.FILES_URL + 'web/' + AboneveritabaniData.Imageurl" alt="">
                </div>
                <div class="new-header">
                  <div class="type">
                    Kaynak Türü: {{AboneveritabaniData.Kaynakturu}}
                  </div>
                  <div class="new-date">
                    <span class="date">{{AboneveritabaniData.Suresi }}</span>
                  </div>
                </div>
                <div class="new-content mt-5">
                  <span style="font-weight: bold;">{{ $t("aboneveritabanidetails.Table.Icerik") }}: </span><span
                    v-html="AboneveritabaniData.Icerik"></span><br />
                </div>
                <div class="new-content mt-2">
                  <span style="font-weight: bold;">{{ $t("aboneveritabanidetails.Table.Hakkinda") }}: </span><span
                    v-html="AboneveritabaniData.Hakkinda"></span><br />
                </div>
                <div class="new-content mt-5">
                  <b-button type="button" class="btn btn-black col-md-1" v-if="AboneveritabaniData.Link != null">
                    <i class="mdi mdi-text-search"></i>

                    <a :href="AboneveritabaniData.Link" target="_newblank" style="color:aliceblue">
                      {{ $t("aboneveritabanidetails.Table.Link") }}</a>
                  </b-button>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
        